import React, { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "./ui/button";
import { navLinks, company } from "../mock";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-40 transition-all ${
        scrolled
          ? "bg-white/90 backdrop-blur-md border-b border-slate-200 shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-16 flex items-center justify-between">
        <a href="#home" className="flex items-center gap-2">
          <div className="h-9 w-9 rounded-lg bg-slate-900 text-white grid place-items-center font-bold tracking-tight">
            4<span className="text-cyan-400">11</span>
          </div>
          <div className="leading-tight">
            <div className="font-bold text-slate-900 text-[15px]">{company.name}</div>
            <div className="text-[10px] uppercase tracking-widest text-slate-500">Tech · Marketing · AI</div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm font-medium text-slate-700 hover:text-cyan-700"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={`tel:${company.phone}`}
            className="flex items-center gap-2 text-sm font-semibold text-slate-900 hover:text-cyan-700"
          >
            <Phone className="h-4 w-4" />
            {company.phone}
          </a>
          <Button
            asChild
            className="bg-cyan-600 hover:bg-cyan-700 text-white font-semibold"
          >
            <a href="#contact">Get Started</a>
          </Button>
        </div>

        <button
          className="lg:hidden p-2 text-slate-900"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-slate-200">
          <div className="max-w-7xl mx-auto px-5 py-4 flex flex-col gap-3">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-slate-800 font-medium py-2 border-b border-slate-100"
              >
                {l.label}
              </a>
            ))}
            <a
              href={`tel:${company.phone}`}
              className="flex items-center gap-2 text-cyan-700 font-semibold py-2"
            >
              <Phone className="h-4 w-4" /> {company.phone}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
